import { Currency } from "./currencies";

export class Money {
  constructor(
    readonly amount: number,
    readonly currency: Currency,
  ) {}
}
